<span class="spinner" *ngIf="loading">
  <fa-icon [icon]="faSpinner" [pulse]="true" size="3x" [fixedWidth]="true"></fa-icon>
</span>
<p-toast></p-toast>

<app-navbar [title]="title"></app-navbar>

<div class="container-fluid main">
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>

<!-- Show some background text to indicate we are on a development system. -->
<div *ngIf="watermark" class='watermarked' attr.data-watermark="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{watermark}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"></div>
